export default __webpack_public_path__ + "static/media/stock8.372ca751.jpg";